import { memo } from "react";
import {
  Circle as _Circle,
  Path as _Path,
  Rect as _Rect,
  Svg as _Svg
} from "react-native-svg";
import { themed } from "../../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return <_Svg viewBox="0 0 256 256" {...otherProps} height={size} width={size}>
    <_Rect width="256" height="256" fill="none" />
    <_Path
      d="M184,184H69.8L41.9,30.6A8,8,0,0,0,34.1,24H16"
      fill="none"
      stroke={`${color}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="12"
    />
    <_Circle
      cx="80"
      cy="204"
      r="20"
      fill="none"
      stroke={`${color}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="12"
    />
    <_Circle
      cx="184"
      cy="204"
      r="20"
      fill="none"
      stroke={`${color}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="12"
    />
    <_Path
      d="M62.5,144H188.1a15.9,15.9,0,0,0,15.7-13.1L216,64H48"
      fill="none"
      stroke={`${color}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="12"
    />
  </_Svg>;
};
Icon.displayName = "ShoppingCartLight";
const ShoppingCartLight = memo(themed(Icon));
export {
  ShoppingCartLight
};
//# sourceMappingURL=shopping-cart-light.js.map
